module.exports = __webpack_public_path__ + "static/media/tra_hi_vis_tru.6188f0bc.png";